export enum Permission {
  PartnerPickDevicesManageShoppers = 'manage_shoppers.legacy_permission',
  PartnerBulkDeliveryVehiclesModify = 'partner_bulk_delivery_vehicles.modify',
}
